// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2a2tv","author":"Table_author__3EcfY","authorImage":"Table_authorImage__ej5Tx","unreadRow":"Table_unreadRow__38si_"};